// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"8d944a6e","452":"268b51c3","453":"68693753","591":"683b951d","880":"024043dc"}[chunkId] + ".chunk.js";
};